import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MobileLayout from '../templates/MobileLayout';
import RiderDashboard from './RiderDashboard';
import LoginPage from '../../pages/LoginPage';
import AuthCallbackPage from '../../pages/AuthCallbackPage';
import UnauthorizedPage from '../../pages/UnauthorizedPage';
import PackHistoryPage from '../../pages/PackHistoryPage';
import TransactionHistoryPage from '../../pages/TransactionHistoryPage';
import PackTemplateBrowserPage from '../../pages/PackTemplateBrowserPage';
import KhaltiReturnPage from '../../pages/KhaltiReturnPage';
import AccountPage from '../../pages/AccountPage';
import AuthGuard from '../guards/AuthGuard';
import PrivateRoute from '../guards/PrivateRoute';

const AppRouter: React.FC = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={
        <AuthGuard requireAuth={false}>
          <LoginPage />
        </AuthGuard>
      } />
      <Route path="/callback" element={<AuthCallbackPage />} />
      <Route path="/logout" element={<Navigate to="/login" replace />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      {/* Protected Routes — single MobileLayout via Layout Route */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route element={<PrivateRoute><MobileLayout /></PrivateRoute>}>
        <Route path="/dashboard" element={<RiderDashboard />} />
        <Route path="/packs" element={<PackHistoryPage />} />
        <Route path="/packs/browse" element={<PackTemplateBrowserPage />} />
        <Route path="/scooter-packs" element={<Navigate to="/packs?type=scooter" replace />} />
        <Route path="/wallet" element={<TransactionHistoryPage />} />
        <Route path="/wallet/khalti/return" element={<KhaltiReturnPage />} />
        <Route path="/account" element={<AccountPage />} />
      </Route>
    </Routes>
  );
};

export default AppRouter;
